import { IRoute, IRouteState } from '@interfaces/App.interface';

/**
 * Generates a new array of history routes based on the given history routes and a new route.
 *
 * @param {IRoute[]} historyRoutes - An array of history routes.
 * @param {IRoute} route - The new route to be added to the history routes.
 * @param {IRouteState} options -  Options for the new route.
 * @return {IRoute[]} The updated array of history routes.
 */
export const goToRoute = (historyRoutes: IRoute[], route: IRoute, options?: IRouteState): IRoute[] => {
  const noSaveRouteId = ['login', 'callback', 'home', 'forgotPassword'];
  if (noSaveRouteId.includes(route.id)) return [...historyRoutes];

  let copyHistoryRoutes = [...historyRoutes];
  const lastPosRoute = copyHistoryRoutes[copyHistoryRoutes.length - 1];
  if (options?.replace && lastPosRoute) {
    lastPosRoute.fullPath = route.fullPath;
    return copyHistoryRoutes;
  }

  if (copyHistoryRoutes.length > 0 && copyHistoryRoutes[copyHistoryRoutes.length - 1].fullPath === route.fullPath) {
    return copyHistoryRoutes;
  }

  if (options?.menuOption?.name || options?.title) {
    route.pageTitle = options?.menuOption?.name ?? options?.title ?? 'Unknown';
    route.pageTitle = route.pageTitle.replace('Any | ', '').replace('undefined | ', '')
    route.routeLastBread = options?.routeLastBread;
  }
  if (options?.resetHistoryLevel !== undefined) {
    copyHistoryRoutes = copyHistoryRoutes.slice(0, options.resetHistoryLevel);
    copyHistoryRoutes.push(route);
  } else {
    const removeElementsAfter = (array: IRoute[], element: IRoute): IRoute[] => {
      let index = -1;

      for (let i = 0; i < array.length; i++) {
        if (array[i].fullPath === element.fullPath) {
          index = i;
          break;
        }
      }

      if (index !== -1) {
        array.splice(index + 1);
      }

      return array;
    };

    const backRoute = removeElementsAfter([...copyHistoryRoutes], route);

    if (backRoute.length < copyHistoryRoutes.length) {
      copyHistoryRoutes = backRoute;
    } else if (route.matchPath !== '/home') {
      copyHistoryRoutes.push(route);
    }
  }

  return copyHistoryRoutes;
};

/**
 * Updates the last route in the history routes array with the given title and route last bread. we need this for creatio new tab
 * @param {IRoute[]} historyRoutes - The array of history routes.
 * @param {IRouteState} options - The options for the new route.
 * @return {IRoute[]} The updated array of history routes.
 */
export const updateLastBread = (historyRoutes: IRoute[], options: IRouteState) => {
  const lastBread = historyRoutes[historyRoutes.length - 1];
  if (lastBread && options.title) {
    const urlWithoutParams = window.location.pathname;
    window.history.replaceState({}, '', urlWithoutParams);
    lastBread.pageTitle = options.title;
    lastBread.routeLastBread = options.routeLastBread;
    lastBread.fullPath = urlWithoutParams;
  }


  return historyRoutes;
};
